import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/Icon'
import Button from 'components/UI/Button'

import './compact-form-row.pcss'

const CompactFormRow = (props) => {
    const {
        className,
        onClick,
        label,
        children,
        editable,
        iconName,
        trackName,
        expandable,
        iconFlip,
        editIcon,
    } = props

    return (
        <div className={classNames('compact-form-row', className)}>
            {onClick && (
                <Button
                    type="button"
                    className="compact-form-row__overlay-button"
                    onClick={onClick}
                    trackName={trackName}
                />
            )}
            <div className="compact-form-row__left">
                <div className="compact-form-row__icon-container">
                    {iconName && (
                        <Icon
                            fa
                            name={iconName}
                            size="m"
                            cssClass="compact-form-row__icon"
                            flip={iconFlip}
                            color="#b1b1b1"
                        />
                    )}
                </div>
                <div className="compact-form-row__label">
                    {label}
                </div>
            </div>
            <div className="compact-form-row__right">
                {children && (
                    <div className="compact-form-row__content">
                        {children}
                    </div>
                )}
                {editable && (
                    <div className="compact-form-row__action">
                        <Icon name="icon_chevron_down" size="m" />
                    </div>
                )}
                {expandable && (
                    <div className="compact-form-row__action">
                        {editIcon || <Icon name="icon_plus" size="m" />}
                    </div>
                )}
            </div>
        </div>
    )
}

CompactFormRow.propTypes = {
    trackName: PropTypes.string.isRequired,
    icon: PropTypes.node,
    iconName: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    iconFlip: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    editable: PropTypes.bool,
    children: PropTypes.node,
    expandable: PropTypes.bool,
    expandContent: PropTypes.node,
    className: PropTypes.string,
    editIcon: PropTypes.node,
}

export default CompactFormRow
